//Config option loại mẫu số hóa đơn
export default {
  VatInvoice: 1, //Hóa đơn giá trị gia tăng
  Bill: 2, //Hóa đơn bán hàng
  DeliveryBillFreight: 3,//Phiếu xuất kho kiêm vận chuyển hàng hóa nội bộ
  DeliveryBillAgentSales: 4,//Phiếu xuất kho gửi bán hàng đại lý
  ExportBill: 5,//Hóa đơn xuất khẩu
  BillOfSale: 6,//Hóa đơn bán hàng (dành cho tổ chức, cá nhân trong khu phi thuế quan)
  ElecInvoicePublicProperty: 7,//Hoá đơn điện tử bán tài sản công
  ElecInvoiceNationalReserves: 8,//Hoá đơn điện tử bán hàng dự trữ quốc gia
  DiffBills:9,//Hoá đơn khác (tem, vé, thẻ...)
  Documents:10,//Chứng từ như hoá đơn (PXK kiêm vận chuyển nội bộ, PXK hàng gửi bán đại lý)
};
